import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import 'chosen-js/chosen.css';
import chosen from 'chosen-js/chosen.jquery';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

require( 'datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class HemovigilanceReport extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {
			start_date 	: "",
			end_date 	: "",
			
			listado:[],

			//test datatable to export
			columns:[
				{title:'Tipo Componente'},
				{title:'Nombre Componente'},
				{title:'Menos de 4 Hrs. Inicio Transfusión'},
				{title:'Más de 4 Hrs. Inicio Transfusión'},
				{title:'Total'}
			],
			filename:"Estadísticas de Transfusiones",
			date_hour:"",
            medical:"",
            
            services:[],
			destinations:[],
			shipping_destinations:'all',
            health_services:"all",
            work_sessions:[],
			work_session_id:"all",
			components:[],
			options_array:[],
			option:"all",
			listado_pdf:[],
			totals:[]
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
        })
        
        fetch(Config.default.apiGateway.URL+'lookups?type=health_services&option=actives&order=true', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({services:response});
			}
        });

		fetch(Config.default.apiGateway.URL+'lookups?type=SHIPPING_DESTINATIONS&option=actives&order=true', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({destinations:response});
			}
        });
        
        fetch(Config.default.apiGateway.URL+'work_sessions/by_health_facility?health_facilities_id='+this.state.health_facilities_id, {
            method: 'GET',
           headers: new Headers({
               'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
               'Accept'		: 'application/json',
               'Content-Type'	: 'application/json'
           })
        }).then(res => {
           if(res.ok){
               return res.json();
           }else{
               res.text().then((msg)=>{
                   swal('Error', msg, 'error');
               });
           }
       	}).then(response => {
           if(response !== undefined){
               this.setState({
                   work_sessions: response
               });
           }
	   	});

	   	fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				response.unshift({name:'Todos', key:'all'});

				this.setState({components:response});

				this.$select = $(this.select);
				this.$select.chosen();
				this.$select.on('change', (e)=>{
					this.handleChange(e);
				});
			}
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){		
		var fechas = "Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY") 

		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
						var head = []
						this.state.columns.map((c, i)=>{
							if(i > 0){
								head.push({text:c.title, style:'tableHeader'})
							}
							
						})

						this.state.listado_pdf.unshift(head);
						this.state.listado_pdf.push([
							{text:'Totales'},
							{text:this.state.totals.less_four, alignment:'right'},
							{text:this.state.totals.plus_four, alignment:'right'},
							{text:this.state.totals.total, alignment:'right'}
						]);

						doc.content[3].table.body = this.state.listado_pdf;

                		doc.content[3].table.widths= ["45%","20%","20%","15%",];
						doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
			],
			rowGroup: {
	            dataSrc: [ 0 ],
	            startRender: ( rows, group )=>{
	            	var head = rows.data().pluck(0)[0];
	            	var totals = rows.data()[0];
					var tds = '';
					console.log(group, totals)
	            	if(head !== ""  && group !== "" ){
	            	
	            		totals.map((t, i)=>{
	            			if(i === 0){
								tds += '<td>'+t+'</td>'
	            			}else if(i>1){
	            				if(t === ""){
	            					tds += '<td style="text-align:right;">'+
	            								'<div style="visibility:hidden">0</div>'+
	            							'</td>'
	            				}else{
	            					tds += '<td style="text-align:right">'+t+'</td>'
	            				}
								
	            			}
	            			
	            		})
	            		return $('<tr/>').append( tds )
            			
            		}else{return $('<tr/>')};
	            },
	        },
	        columnDefs:[ {
	            targets: [ 0 ],
	            visible: false
			},{
		        targets: [2,3,4],
		        className: 'dt-right'
    		}],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			createdRow: (row, data, dataIndex)=>{
				data.map((d, i)=>{
					
					if(data[1] === ""){
						$(row).attr('style', 'display:none');
					}
						
				});

			}	
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		if(e.target.name === 'options_array'){
			var options = e.target.options;
			var value = [];
			for (var i = 0, l = options.length; i < l; i++) {
			    if (options[i].selected) {
			    	if(options[i].value === 'all'){
			    		value = [];
			    		value.push('all');
			    		break;
			    		
			    	}else{
			    		value.push(options[i].value);
			    	}
			    }
			}

			this.setState({
				[e.target.name]: value
			});

			this.$select.val(value).trigger("chosen:updated");
		}else{
			this.setState({
				[e.target.name]: e.target.value
			});
		}
		

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
		
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var options =[];
				if(this.state.options_array.findIndex(obj => obj === 'all') !== -1){
					this.state.components.map((o, i)=>{
						if(i > 0){
							options.push(o.key);
						}
					});
				}else{
					options = this.state.options_array
				}

				var object = {
					health_facilities_id:sessionStorage.getItem('health_facilities_id'),
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					health_service: this.state.health_services,
					work_sessions_id: this.state.work_session_id,					
					shipping_destinations: this.state.shipping_destinations,
					options_array: options
				};

				fetch(Config.default.apiGateway.URL+'reports/transfutional_stats', {
					method : 'post',
					body:JSON.stringify(object),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				})
				.then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				})
				.then(response => {
					
					if (response !== undefined) { 
						var list = [], list_pdf=[];
						
						response.resp.map((res, i)=>{
							var obj = [res.component_type, '', res.less_four, res.plus_four, res.total];
							var obj_pdf = [
								{text:res.component_type,bold:1,fillColor:'#dfdfdf'},
								{text:res.less_four, bold:1,fillColor:'#dfdfdf', alignment:'right'},
								{text:res.plus_four, bold:1,fillColor:'#dfdfdf', alignment:'right'},
								{text:res.total, bold:1,fillColor:'#dfdfdf', alignment:'right'},
							];
							list.push(obj);
							list_pdf.push(obj_pdf);
							res.components.map((comp)=>{
								obj = [res.component_type];
								obj_pdf = [];
								obj.push(
									comp.component,
									comp.less_four,
									comp.plus_four,
									comp.total
								)

								obj_pdf = [
									{text:comp.component},
									{text:comp.less_four, alignment:'right'},
									{text:comp.plus_four, alignment:'right'},
									{text:comp.total, alignment:'right'},
								];
								list_pdf.push(obj_pdf);
								list.push(obj);
							})

						})
						
						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							listado: list,
							listado_pdf: list_pdf,
							totals: response.totals
						});
					} else {
						swal('Error', 'Campos Incompletos', 'error');
					}
						
				})
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}

		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	} 	

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Pacientes ->
					{this.state.filename}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_patients"} 
		            submenu={"help_transfutional_stats"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
                                <div className="form-group">
									<span className="span-min">Servicio</span>
									<select className="form-control" name="health_services" id="health_services"
										value={this.state.health_services} onChange={this.handleChange}>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.services.map((f, i)=>{
											return <option key={i} value={f.id}>
												{f.name}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Servicio Destino</span>
									<select className="form-control" name="shipping_destinations" id="shipping_destinations"
										value={this.state.shipping_destinations} onChange={this.handleChange}>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.destinations.map((f, i)=>{
											return <option key={i} value={f.key}>
												{f.name}
											</option>
										})}
									</select>
								</div>

                                <div className="form-group">
									<span className="span-min">Turno</span>
									<select className="form-control" name="work_session_id" id="work_session_id" 
										value={this.state.work_session_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.work_sessions.map((w, i)=>{
											return <option key={i} value={w.id}>
												{w.value}
											</option>
										})}
									</select>
								</div>

                                <div className="form-group">
									<span className="span-min">Tipo de Componente</span>
									<select className="form-control"  name="options_array" id="options_array"
										value={this.state.options_array} 
										multiple={true} required data-placeholder={'Seleccione...'}
										ref={el => this.select = el}>
										{this.state.components.map((l, i)=>{
											return <option key={i} value={l.key}>
												{l.name}
											</option>
										})}
									</select>
								</div>
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12 col-sm-12" >
										<span>
											Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>
								</div>

								<div className="col-xs-12 form-group" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}}  id="table-to-xls" className="expenses-discards" ref={el => this.el = el}>
										</table>
									</div>

								</div>
								<div className="col-xs-12 form-group">
									<table className="expenses-discards table">
										<tbody>
											<tr>
												<td>Totales</td>
												<td style={{textAlign:'right', paddingRight:'15px'}}>{this.state.totals.less_four}</td>
												<td style={{textAlign:'right', paddingRight:'15px'}}>{this.state.totals.plus_four}</td>
												<td style={{textAlign:'right', paddingRight:'15px'}}>{this.state.totals.total}</td>
												
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (HemovigilanceReport);